import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  //モーダル表示
  modalShow(e) {
    var target = $(e.currentTarget).attr("data-target");
    var targetModal = document.querySelector(target);
    $(target).fadeIn(300);
    targetModal.showModal();
    targetModal.classList.add("is-open");
    this.htmlFix();
    document.activeElement.blur();
  }

  cancel() {
    this.modalClose();
  }

  linkClick(e) {
    $(e.currentTarget).attr("aria-disabled", "true");
    this.htmlScroll();
  }

  // ESCキーを押したときの処理を無効化し、modalClose()を発火
  keydown(e) {
    //プレビュー中は閉じない
    if ($(".modal").hasClass("is-initial-open") && e.key === "Escape") {
      e.preventDefault(); // デフォルトのESCキー処理を無効化
      return;
    } else if ($(".modal").hasClass("is-open") && e.key === "Escape") {
      e.preventDefault(); // デフォルトのESCキー処理を無効化
      this.modalClose();
    }
  }

  //オーバーレイクリックで閉じる
  overlay(e) {
    var target = $(e.target);
    if (!target.closest(".js-modal-content").length) {
      this.modalClose();
    }
  }

  //モーダル閉じる処理
  modalClose() {
    var openModal = document.querySelector(".js-modal.is-open");

    if (openModal) {
      $(".js-modal").fadeOut(300);
      setTimeout(function () {
        openModal.close();
      }, 300);
      openModal.classList.remove("is-open");
      this.htmlScroll();
      if ($("#submit-button")) {
        $("#submit-button").prop("disabled", false);
      }
    }
  }

  //PC時のみ表示のモーダル、リサイズ時の処理
  resize() {
    var windowWidth = $(window).width();
    if (windowWidth < 768 && $(".js-modal").hasClass("only-pc")) {
      this.modalClose();
    }
  }

  //スクロール禁止状態にする
  htmlFix() {
    var st = $(window).scrollTop() * -1;
    $("html").addClass("is-fixed");
    $("body").css("top", st);
  }

  //スクロール禁止状態を解除する
  htmlScroll() {
    var st = parseFloat($("body").css("top")) * -1;
    $("html").removeClass("is-fixed").scrollTop(st);
    $("body").removeAttr("style");
  }

  copyUrl(e) {
    e.preventDefault();
    const url = window.location.href; // 現在のURLを取得
    navigator.clipboard.writeText(url);
  }

  shareByEmail(e) {
    e.preventDefault();
    const url = window.location.href; // 現在のURLを取得
    const subject = "このページをシェア";
    const body = `こちらのリンクをご覧ください: ${url}`;
    window.location.href = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
  }

  shareByLine(e) {
    e.preventDefault();
    const url = encodeURIComponent(window.location.href);
    const text = encodeURIComponent("こちらのリンクをご覧ください: ");
    const lineShareUrl = `https://social-plugins.line.me/lineit/share?url=${url}&text=${text}`;
    window.open(lineShareUrl, "_blank");
  }

  shareByFacebook(e) {
    e.preventDefault();
    const url = encodeURIComponent(window.location.href);
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
    window.open(facebookShareUrl, "_blank");
  }

  shareByX(e) {
    e.preventDefault();
    const url = encodeURIComponent(window.location.href);
    const text = encodeURIComponent("こちらのリンクをご覧ください: ");
    const xShareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${text}`;
    window.open(xShareUrl, "_blank");
  }
}
